import { i18n } from '@/plugins/i18n'
import { paymanStatusStr, paymanVariant } from '@/constants/paymanStatus'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.user.id + '/details">'+row.user.full_name+'</a>'
        },
    },
    {
        field: 'farsi_name',
        title: i18n.t('label.gateway_title'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'phone_number',
        title: i18n.t('label.ivr_phone_number'),
        sortable: false,
        textAlign: 'center',
        template: (row) => '<span dir="ltr">'+row.phone_number+'</span>',
        width: 120
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        textAlign: 'center',
        template: (row) => '<span dir="ltr">'+row.created_at+'</span>',
        width: 90
    },
    {
        field: 'status',
        sortable: true,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = paymanStatusStr.get(row.status)
            let variant = 'badge-'+paymanVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 80
    },
]